import { Badge } from "@/components/shadcn/badge";
import { useTranslations } from "next-intl";

export function RequirementBadge({ isPremium }: { isPremium: boolean }) {
    const t = useTranslations("events");

    return isPremium ? (
        <Badge variant="destructive">{t("premiumMembers")}</Badge>
    ) : (
        <Badge variant="secondary">{t("allMembers")}</Badge>
    );
}
